// Utility to detect duplicated first/last names and to surface the
// certificate-name confirmation prompt before submitting registration forms.

export function checkNameDuplicate(firstName, lastName) {
    if (!firstName || !lastName) return null
    const f = String(firstName).trim().toLowerCase()
    const l = String(lastName).trim().toLowerCase()
    if (!f || !l) return null
    if (f === l) {
        return 'First name and last name are identical.'
    }
    if (f.includes(l) || l.includes(f)) {
        return 'First name and last name appear to contain each other.'
    }
    return null
}

export function collectNameWarnings(namePairs) {
    const warnings = []
    for (const pair of namePairs) {
        const err = checkNameDuplicate(pair.first, pair.last)
        if (err) {
            const prefix = pair.label ? `${pair.label}: ` : ''
            warnings.push(`${prefix}${err}`)
        }
    }
    return warnings
}

function escapeHtml(s) {
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

export function checkAndConfirmName(vm, namePairs) {
    const warnings = collectNameWarnings(namePairs)
    if (!warnings.length) return Promise.resolve()
    const panelId = 'name-verify-why-' + Math.random().toString(36).slice(2, 9)
    const warningsHtml = warnings
        .map(w => `<p style="margin:0 0 6px 0;">${escapeHtml(w)}</p>`)
        .join('')
    const toggleScript =
        `var el=document.getElementById('${panelId}');` +
        `if(el){el.style.display=(el.style.display==='block'?'none':'block');}` +
        `return false;`
    const message =
        warningsHtml +
        '<p style="margin:10px 0 0 0;">' +
            'The name you entered will be printed on your certificate, so it must be verified. ' +
            'Any changes to the name or school information requested after the certificate has been issued ' +
            'might incur a paid correction service fee' +
            ` <a href="javascript:void(0)" onclick="${toggleScript}" ` +
                `style="color:#409EFF;text-decoration:underline;">Why?</a>` +
            '.' +
        '</p>' +
        `<div id="${panelId}" class="name-verify-why-panel" style="display:none;">` +
            '<p style="margin:0 0 8px 0;">' +
                'Correcting a registered name is not automatic — each request requires a staff member to ' +
                'review your emails, update the record across our systems, and reply to confirm the change. ' +
                'For free registration programs, that work is what the correction fee covers.' +
            '</p>' +
            '<ol style="margin:0;padding-left:20px;">' +
                '<li style="margin-bottom:6px;">' +
                    'There is a meaningful cost behind every correction — staff time and coordination are real work.' +
                '</li>' +
                '<li style="margin-bottom:6px;">' +
                    'The fee encourages responsible registration. You can certainly avoid it by being careful when entering your information.' +
                '</li>' +
                '<li>' +
                    'The fee is based on the reasonable time required to complete the correction and the corresponding staff cost at our headquarters.' +
                '</li>' +
            '</ol>' +
        '</div>'
    return vm.$confirm(message, 'Please verify your name', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Confirm, my information is correct',
        cancelButtonText: 'Let me double-check',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: 'name-verify-dialog'
    })
}
